module.exports = __webpack_public_path__ + "static/media/add_queue.06c99208.svg";